
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iamblichean-vs-astrological-theurgy",
      function () {
        return require("private-next-pages/iamblichean-vs-astrological-theurgy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iamblichean-vs-astrological-theurgy"])
      });
    }
  